import { getWarehouseIntegrationsHealth } from '@gonfalon/openapi/operations/getWarehouseIntegrationsHealth';
import { getWarehouseNativeIntegrationHealth } from '@gonfalon/openapi/operations/getWarehouseNativeIntegrationHealth';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getWarehouseIntegrationsHealthQuery = createQueryOptions(getWarehouseIntegrationsHealth);
export const getWarehouseNativeIntegrationHealthQuery = createQueryOptions(getWarehouseNativeIntegrationHealth);
